<template>
  <div class="welcome-card upcoming-appointments-card">
    <div class="card-header">
      <div class="card-title-group">
        <i class="fas fa-calendar-alt card-title-icon"></i>
        <h3 class="card-title">Today's Upcoming Appointments</h3>
      </div>
      <button class="view-all-link" @click="$emit('view-all')">
        View all <i class="fas fa-arrow-right"></i>
      </button>
    </div>

    <div class="card-body">
      <div v-if="isLoading" class="card-empty">Loading...</div>
      <div v-else-if="!appointments.length" class="card-empty">
        No upcoming appointments
      </div>
      <div v-for="appt in appointments" :key="appt.id" class="appointment-row">
        <div class="appointment-time">{{ appt.time }}</div>
        <div class="appointment-details">
          <div class="appointment-name-row">
            <span class="appointment-name">{{ appt.patientName }}</span>
          </div>
          <div class="appointment-meta">
            {{ appt.type }} · {{ appt.service }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "UpcomingAppointmentsCard",
  computed: {
    ...mapState({
      appointments: (state) => state.appointments.upcomingAppointments,
      isLoading: (state) => state.appointments.upcomingAppointmentsLoading,
      user: (state) => state.auth.user,
    }),
  },
  mounted() {
    if (this.user) {
      this.$store.dispatch("appointments/getUpcoming", {
        userId: this.user.id,
        isProvider: this.user.isProvider,
        isAdmin: this.user.isAdmin,
        isManagingAdmin: this.user.isManagingAdmin,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.welcome-card {
  background: var(--oliver-bg-surface, rgba(255, 255, 255, 0.7));
  border: 1px solid var(--oliver-border, rgba(0, 0, 0, 0.06));
  border-radius: 14px;
  padding: 10px 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  backdrop-filter: blur(6px);

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0;
  background: none;
  border: none;
}

.card-title-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.card-title-icon {
  font-size: 14px;
  color: var(--oliver-accent);
}

.card-title {
  font-size: 15px;
  font-weight: 600;
  color: var(--oliver-text);
  margin: 0;
}

.view-all-link {
  background: none;
  border: none;
  color: var(--oliver-accent);
  opacity: 0.85;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 6px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: opacity 0.2s ease;

  i {
    font-size: 10px;
  }

  &:hover {
    opacity: 1;
  }
}

.card-body {
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 0;
  flex: 1;
  overflow-y: auto;
  min-height: 0;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.15);
    border-radius: 2px;
  }
}

.appointment-row {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.appointment-time {
  flex-shrink: 0;
  width: 76px;
  font-size: 13px;
  font-weight: 600;
  color: var(--oliver-text);
  line-height: 1.35;
}

.appointment-details {
  flex: 1;
  min-width: 0;
}

.appointment-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 1px;
}

.appointment-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--oliver-text);
}

.appointment-meta {
  font-size: 12px;
  color: var(--oliver-text);
  opacity: 0.65;
  line-height: 1.2;
}

.card-empty {
  font-size: 13px;
  color: var(--oliver-greeting-subtitle);
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
